module.exports = __webpack_public_path__ + "media/images/icons/flags/ET-c53fb583bc9bb24200d43270f228730f.svg";